import * as React from "react";
import { Typography, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  wrapper: {
    display: "block",
    margin: "2.5px",
    float: "right" as any,
    borderRadius: "45px",
    overflow: "hidden",
    cursor: "pointer",
  },
  container: {
    backgroundColor: theme.palette.secondary.dark,
    height: "42px",
    borderRadius: "45px",
    display: "table",
    padding: "4px 4px 4px 18px",
  },
  text: {
    fontFamily: "Roboto",
    fontSize: "10px",
    color: theme.palette.secondary.light,
    textTransform: "uppercase" as any,
    marginRight: "17px",
    whiteSpace: "nowrap" as any,
    lineHeight: "42px",
  },
  circle: {
    display: "table-cell",
    verticalAlign: "middle",
    height: "42px",
    minWidth: "42px",
    borderRadius: "21px",
    backgroundColor: theme.palette.primary.light,
  },
  icon: {
    margin: "0 auto",
    fontSize: "15px",
    display: "block",
    color: theme.palette.secondary.light,
  },
});

type IProps = {
  text: string;
  Icon: any;
  onClick: any;
  classes: any;
};

class DropdownItem extends React.Component<IProps> {
  render() {
    const { text, Icon, onClick, classes } = this.props;
    return (
      <span className={classes.wrapper} onClick={onClick}>
        <div className={classes.container}>
          <Typography className={classes.text} component="span">
            {text}
          </Typography>
          <span className={classes.circle}>
            <Icon className={classes.icon} />
          </span>
        </div>
      </span>
    );
  }
}
export default withStyles(styles)(DropdownItem);



// WEBPACK FOOTER //
// ./src/modules/profile/components/layouts/DropdownItem.tsx